<template>
  <section class="topstyle">
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      style="margin: 10px auto 0px 15px"
    ></toolbar>
    <el-select
      v-model="filters.ActivityTypeId"
      placeholder="请选择类型"
      id="inputselect"
      style="width: 200px; margin: 0px auto 10px 15px"
      @change="selecttypelist()"
    >
      <el-option
        v-for="(item, index) in coursetypelist"
        :key="index"
        :label="item.Name"
        :value="item.Id"
      ></el-option>
    </el-select>

    <!--列表-->
    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '90px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column> -->
      <el-table-column
        type="index"
        width="60"
        label=" "
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Id"
        label="ID"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ActivityTypeName"
        label="分类"
        width="200"
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="标题"
        width="200"
        sortable
        align="center"
      ></el-table-column>
      <!-- <el-table-column
        prop="Briefing"
        label="简介"
        width="150"
        sortable
         :show-overflow-tooltip="true"
      ></el-table-column> -->
      <el-table-column
        prop="Score"
        label="分数"
        width="100"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Maxmember"
        label="报名人数"
        width="100"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ListImg"
        label="封面"
        width="100"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <div>
            <el-image
              :src="scope.row.ListImg"
              fit="contain"
              @click.native="Logimg.push(scope.row.ListImg)"
            >
            </el-image>
          </div>
        </template>
        <!-- 图片的显示 -->
      </el-table-column>
      <el-table-column prop="IsStick" label="是否置顶" align="center" sortable>
        <template slot-scope="scope">
          <div style="text-align: center">
            {{ scope.row.IsStick === false ? "否" : "是" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        sortable
        align="center"
      ></el-table-column>
      <!-- <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="onLookDatas(scope.row.Id)"
            >课程目录</el-button
          >
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="200px" align="center">
        <template slot-scope="scope">
          <span
            class="SpanList"
            @click="creatQrCode(scope.row.IdentifierOne, scope.row.Id)"
            >查看二维码</span
          >
          <span class="SpanList" @click="handleEdit(scope.row.Id)">编辑</span>
          <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
        style="margin-top: 20px"
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="15"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      @opened="Editwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          编辑
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="editForm"
        label-width="90px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="课程标题" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动地址" prop="Address">
          <el-input v-model="editForm.Address" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="课程分类" prop="ActivityTypeId">
          <el-select
            v-model="editForm.ActivityTypeId"
            placeholder="请选择课程分类"
          >
            <el-option
              v-for="(item, index) in coursetypelist"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img
              v-if="editForm.ListImg"
              :src="editForm.ListImg"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否置顶" prop="IsStick">
          <el-select v-model="editForm.IsStick" placeholder="请选择状态">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="课程或者文章" prop="IsStick">
          <el-select v-model="addForm.Istrue" placeholder="请选择状态">
            <el-option label="课程" value="true"></el-option>
            <el-option label="文章" value="false"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="参与人数" prop="Maxmember">
          <!-- auto-complete="on"? -->
          <el-input
            v-model="editForm.Maxmember"
            style="width: 200px"
          ></el-input>
        </el-form-item>

        <el-form-item label="分数">
          <el-input v-model="editForm.Stroc" style="width: 200px"></el-input
        ></el-form-item>
        <el-form-item label="是否发布" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Statuslist"
              :label="item.Name"
              :value="item.Status"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动介绍" prop="Notice">
          <div class="edit_container" id="edit_containerNotice"></div>
        </el-form-item>
        <!--使用编辑器
        -->
        <el-form-item label="活动流程" prop="Detail">
          <div class="edit_container" id="edit_containerDetail"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      @opened="Addwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          新增
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="addForm"
        label-width="90px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="课程标题" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动地址" prop="Address">
          <el-input v-model="addForm.Address" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="课程分类" prop="ActivityTypeId">
          <el-select
            v-model="addForm.ActivityTypeId"
            placeholder="请选择课程分类"
          >
            <el-option
              v-for="(item, index) in coursetypelist"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img v-if="addForm.ListImg" :src="addForm.ListImg" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否置顶" prop="IsStick">
          <el-select v-model="addForm.IsStick" placeholder="请选择状态">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="课程或者文章" prop="IsStick">
          <el-select v-model="addForm.Istrue" placeholder="请选择状态">
            <el-option label="课程" value="true"></el-option>
            <el-option label="文章" value="false"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="参与人数" prop="Maxmember">
          <el-input
            v-model="addForm.Maxmember"
            auto-complete="on"
            style="width: 200px"
          ></el-input>
        </el-form-item>

        <el-form-item label="分数" prop="Stroc">
          <el-input
            v-model="addForm.Stroc"
            auto-complete="on"
            style="width: 200px"
          ></el-input
        ></el-form-item>
        <el-form-item label="是否发布" prop="Status">
          <el-select v-model="addForm.Status" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Statuslist"
              :label="item.Name"
              :value="item.Status"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动介绍" prop="Notice">
          <div class="edit_container" id="Add_containerNotice"></div>
        </el-form-item>
        <!--使用编辑器
        -->
        <el-form-item label="活动流程" prop="Detail">
          <div class="edit_container" id="Add_containerDetail"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <creatqrcodes
      @closedCodes="closedFnShow"
      :isShowCodes="isShowCodesStatus"
      :Codesvalue="Codesvaluesigin"
      :CodesvalueType="CodesvalueTypeSigin"
    />
  </section>
</template>

<script>
import util from "../../../util/date";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  getactivitiespagelist,
  GetActivitiesType,
  activitiesadd,
  UploadImg,
  activitiesdelete,
  activitiessingle,
  activitiesedit,
  coursecatalogsupdate,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import E from "wangeditor";
import creatqrcodes from "../../components/creatqrcodes";
export default {
  components: { Toolbar, quillEditor, creatqrcodes },
  data() {
    return {
      Codesvaluesigin: "",
      CodesvalueTypeSigin: 0,
      isShowCodesStatus: false,
      editor: null,
      editorNotice: null,
      Logimg: [],
      editorOption: {},
      dialogVisible: false,
      formLabelWidth: "80px",
      limitNum: 1,
      buttonList: [],
      coursetypelist: [],
      Sticklist: [
        { Id: 1, Name: "是", IsStick: true },
        { Id: 2, Name: "否", IsStick: false },
      ],
      Statuslist: [
        { Id: 1, Name: "发布", Status: 2 },
        { Id: 2, Name: "草稿", Status: 1 },
      ],
      currentRow: null,
      filters: {
        name: "",
        ActivityTypeId: null,
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,

      //编辑界面数据
      editForm: {
        //aaa
        Id: 0,
        Address: "", //地址
        Maxmember: 0, //最大报名人数
        ActivityTypeId: null, //所属类别
        Name: "", //标题
        Detail: "", //活动流程
        IsStick: null, // 是否指定
        ListImg: "", //背景图
        Status: null, //发布或者草稿
        //Istrue: "请选择", //
        Stroc: 0,
        Notice: "", //活动介绍
      },
      editFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        ActivityTypeId: [
          { required: true, message: "课程类型", trigger: "blur" },
        ],
        Address: [{ required: true, message: "活动地址", trigger: "blur" }],
        Notice: [
          { required: true, message: "活动介绍未填写", trigger: "blur" },
        ],
        Detail: [
          { required: true, message: "活动流程未填写", trigger: "blur" },
        ],
        ListImg: [{ required: true, message: "图片", trigger: "blur" }],
        IsStick: [{ required: true, message: "未选择", trigger: "blur" }],
        Status: [{ required: true, message: "未选择", trigger: "blur" }],
        ActivityTypeId: [
          { required: true, message: "未选择", trigger: "blur" },
        ],
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        ActivityTypeId: [
          { required: true, message: "课程类型", trigger: "blur" },
        ],
        Address: [{ required: true, message: "活动地址", trigger: "blur" }],
        Notice: [
          { required: true, message: "活动介绍未填写", trigger: "blur" },
        ],
        Detail: [
          { required: true, message: "活动流程未填写", trigger: "blur" },
        ],
        ListImg: [{ required: true, message: "图片", trigger: "blur" }],
        IsStick: [{ required: true, message: "未选择", trigger: "blur" }],
        Status: [{ required: true, message: "未选择", trigger: "blur" }],
        ActivityTypeId: [
          { required: true, message: "未选择", trigger: "blur" },
        ],
        Maxmember: [{ required: true, message: "人数", trigger: "blur" }],
        Stroc: [{ required: true, message: "分数", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Address: "", //地址
        Maxmember: null, //最大报名人数
        ActivityTypeId: null, //所属类别
        Name: "", //标题
        Detail: "", //活动流程
        IsStick: null, // 是否指定
        ListImg: "", //背景图
        Status: null, //发布或者草稿
        //Istrue: "请选择", //
        Stroc: null,
        Notice: "", //活动介绍
      },
    };
  },
  methods: {
    closedFnShow() {
      this.$set(this, "isShowCodesStatus", false);
    },
    creatQrCode(value, type) {
      this.Codesvaluesigin = value;
      this.CodesvalueTypeSigin = type;
      this.$set(this, "isShowCodesStatus", true);
    },
    DialogDown() {
      this.addFormVisible = false;
      this.editFormVisible = false;
    },
    ///新增富文本编辑款
    Addwangeditor() {
      var Notice = document.getElementById("Add_containerNotice").innerHTML;
      var datil = document.getElementById("Add_containerDetail").innerHTML;
      if (datil.length <= 0 || Notice.length <= 0) {
        console.log("chua");
        this.editor = new E("#Add_containerDetail");
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor.create();
        this.editorNotice = new E("#Add_containerNotice");
        this.editorNotice.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editorNotice.create();
      }
      if (datil.length != null || Notice.length != null) {
        this.editor.txt.html("");
        this.editorNotice.txt.html("");
      }
    },
    ///编辑富文本编辑款
    Editwangeditor() {
      var Notice = document.getElementById("edit_containerNotice").innerHTML;
      var datil = document.getElementById("edit_containerDetail").innerHTML;
      //console.log(c);
      if (datil.length <= 0 || Notice.length <= 0) {
        console.log("chua");
        this.editor = new E("#edit_containerDetail");
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor.create();
        this.editorNotice = new E("#edit_containerNotice");
        this.editorNotice.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editorNotice.create();
      }
      if (datil != null && Notice != null) {
        this.editor.txt.html(this.editForm.Detail);
        this.editorNotice.txt.html(this.editForm.Notice);
      }
    },
    // 查看数据
    onLookDatas(id) {
      //this.$router.push('/Course/courseData_index')

      this.$router.push({
        path: "/Course/courseData_index",
        query: { Id: id },
      });
    },
    onEditorReady(editor) {},
    // 上传文件之前的钩子
    handleAvatarSuccess(res, file) {
      this.addForm.ListImg = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "警告",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
      }
      let size = file.size / 1024 / 1024 / 2;
      if (size > 2) {
        this.$notify.warning({
          title: "警告",
          message: "图片大小必须小于2M",
        });
      }
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      UploadImg(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        if (response.data.success) {
          this.addForm.ListImg = response.data.response;
          this.editForm.ListImg = response.data.response;
          console.log("filename", this.addForm.ListImg);
          this.$message.info("文件：" + fileObj.name + "上传成功");
        } else {
          this.$message.info("文件：" + fileObj.name + "上传失败");
        }
      });
    },
    //获取课程类型
    getcoursetypelist() {
      GetActivitiesType({ Type: 1 }).then((res) => {
        console.log(res.data.response);
        this.coursetypelist = res.data.response;
        //this.coursetypelist.push({ Id: 0, Name: "--请选择课程类型--" });
        this.coursetypelist.reverse();
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters.name = item.search;
      console.log(item);
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatbcontent: function (row, column) {
      return row.bcontent ? row.bcontent.substring(20) : "N/A";
    },
    formatCreateTime: function (row, column) {
      // console.log(row);
      return !row.ApplyStartDateTime || row.ApplyStartDateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.ApplyStartDateTime),
            "yyyy-MM-dd "
            // "yyyy-MM-dd hh:mm:ss "
          );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLists();
    },
    getMoudle() {
      console.log("getModules");
      this.getLists();
    },
    selecttypelist() {
      this.page = 1;
      this.getLists();
    },

    //获取列表
    getLists() {
      let para = {
        PageIndex: this.page,
        Name: this.filters.name,
        ActivitiesTypeId: this.filters.ActivityTypeId,
        Type: 1,
      };
      this.listLoading = true;
      getactivitiespagelist(para).then((res) => {
        console.log(res);
        if (res.data.success) {
          this.total = res.data.response.dataCount;
          this.users = res.data.response.data;
          this.listLoading = false;
        } else {
          this.total = 0;
          this.users = [];
          this.listLoading = false;
        }
      });
    },
    //删除
    handleDel(id) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: id };
          activitiesdelete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getLists();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit(id) {
      activitiessingle({ Id: id, type: 1 }).then((res) => {
        if (res.data.success) {
          console.log(res.data.response);
          this.getcoursetypelist();
          this.editFormVisible = true;
          let data={
            ...res.data.response.data,
            Stroc:res.data.response.Stroc
          }
          this.editForm = data
          // this.$set(this, "editForm", res.data.response.data);

          this.$nextTick(() => {
            this.$refs["editForm"].clearValidate();
          });
        }
      });
    },
    //显示新增界面
    handleAddShow() {
      this.addFormVisible = true;
      this.addForm = {
        Address: "", //地址
        Maxmember: null, //最大报名人数
        ActivityTypeId: null, //所属类别
        Name: "", //标题
        Detail: "", //活动流程
        IsStick: null, // 是否指定
        ListImg: "", //背景图
        Status: null, //发布或者草稿
        //Istrue: "请选择", //
        Stroc: null,
        Notice: "", //活动介绍
      };
      this.getcoursetypelist();
      this.$nextTick(() => {
        this.$refs["addForm"].clearValidate();
      });
    },
    //编辑
    editSubmit: function () {
      //this.editor.txt.html(this.editForm.Content);
      //this.editor.txt.html(this.editForm.Content);
      this.editForm.Detail = this.editor.txt.html();
      this.editForm.Notice = this.editorNotice.txt.html();
      console.log(this.editForm);
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            // console.log(para);
            activitiesedit({ data: para, Stroc: para.Stroc, Type: 1 }).then(
              (res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getLists();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              }
            );
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      // if (this.addForm.IsStick == "请选择") {
      //   this.addForm.IsStick = null;
      // }
      // if ((this.addForm.Status = "请选择")) {
      //   this.addForm.Status = null;
      // }
      this.addForm.Detail = this.editor.txt.html();
      this.addForm.Notice = this.editorNotice.txt.html();
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;
            var user = JSON.parse(window.localStorage.user);
            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            activitiesadd({ data: para, Stroc: para.Stroc, Type: 1 }).then(
              (res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.addLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getLists();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              }
            );
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
  },
  // computed: {
  //   editor() {
  //     return this.$refs.myQuillEditor.quill;
  //   },
  // },
  mounted() {
    this.getLists();

    this.getcoursetypelist();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
